export default __webpack_public_path__ + "static/media/r-lemon-tree-tablet.9c5550d9.png";